import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { DueDiligenceCalendar } from '../components/DueDiligenceCalendar'
import {
  actionCreators,
  IDueDiligenceCalendarState,
  selectDownloadUrl,
  selectEndTime,
  selectError,
  selectEvents,
  selectIsLoading,
  selectScope,
  selectStartTime,
} from '../modules/dueDiligenceCalendar'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IDueDiligenceCalendarState & ICurrentUserState
  >({
    downloadUrl: selectDownloadUrl(),
    endTime: selectEndTime(),
    error: selectError(),
    events: selectEvents(),
    isLoading: selectIsLoading(),
    scope: selectScope(),
    startTime: selectStartTime(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(DueDiligenceCalendar)
